<template>
    <vx-table-row>
        <vx-table-row-title>
            {{ formatPhoneNumber(props.modelValue.phone_number) }}
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Number Type: </template>
            {{ formatNumberType(props.modelValue.number_type) }}
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Country: </template>
            {{ countryEmoji(props.modelValue.iso_country) }} {{ props.modelValue.iso_country }}
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Voice: </template>

            <template v-if="props.modelValue.is_hosted"> Hosted </template>
            <template v-else-if="props.modelValue.forward_voice_to"> Forward </template>
            <template v-else-if="props.modelValue.voice_message_text"> Say Message </template>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Sending: </template>

            <font-awesome-icon
                widthAuto
                data-test="used-for-sending-check"
                :icon="faCircleCheck"
                v-if="props.modelValue.use_for_sending"
            ></font-awesome-icon>
        </vx-table-row-item>

        <vx-table-row-item v-if="props.contactGroups">
            <template v-slot:label> Group: </template>

            <div v-if="props.modelValue.group_id">
                <vx-icon-loading v-if="group === undefined" spin></vx-icon-loading>
                <template v-else>
                    <div v-if="group?.name" class="line-clamp-1 font-bold" :title="group.name">
                        {{ group.name }}
                    </div>
                    <div class="break-all text-slate-500">{{ props.modelValue.group_id }}</div>
                </template>
            </div>
            <div v-else>-</div>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Vendor: </template>
            {{ formatVendor(props.modelValue.vendor) }}
        </vx-table-row-item>

        <vx-table-row-buttons>
            <vx-button
                :href="`/kiosk/teams/${props.modelValue.team_id}/phone-numbers/${props.modelValue.id}/voice-changes`"
                data-test="voice-changes"
                color="muted"
                outline
            >
                Voice Changes <font-awesome-icon widthAuto :icon="faClockRotateLeft" />
            </vx-button>
        </vx-table-row-buttons>
    </vx-table-row>
</template>

<script setup lang="ts">
import { faCircleCheck, faClockRotateLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxButton,
    VxIconLoading,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
} from '@voxie/frontend-components';
import { onMounted, ref } from 'vue';
import { formatPhoneNumber } from '~/components/filters';
import { formatNumberType, formatVendor } from '~/constants/phoneNumbers';
import { groupsClient } from '~/services';
import type { Group } from '~/services/groups/groupsClient.types';
import type { PhoneNumber } from '~/services/phoneNumbersClient.types';
import { countryEmoji } from '~/utils/string';

const props = withDefaults(
    defineProps<{
        modelValue: PhoneNumber;
        contactGroups?: boolean;
    }>(),
    { contactGroups: false }
);

const group = ref<Group | null | undefined>(undefined);

const fetchGroup = async () => {
    if (!(props.contactGroups && props.modelValue.group_id)) {
        return;
    }
    group.value = undefined;
    try {
        const { data } = await groupsClient.getGroup({ teamId: props.modelValue.team_id }, props.modelValue.group_id);
        group.value = data;
    } catch {
        group.value = null;
    }
};

onMounted(() => {
    fetchGroup();
});
</script>
